import { Button } from '../../components/ui/Button';

interface Props {
  email: string;
  password: string | null;
  onDismiss: () => void;
}

/**
 * The one moment a console password is visible. The backend stores only its
 * hash, so this panel is the single chance to copy it — hence the deliberate
 * dismiss button rather than a toast that disappears on its own.
 */
export function OneTimePasswordPanel({ email, password, onDismiss }: Props) {
  return (
    <div
      role="status"
      className="mb-5 max-w-2xl rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4"
    >
      <div className="mb-2 text-[13px] font-medium text-[var(--co-text)]">{email} added</div>

      {password ? (
        <>
          <p className="mb-2 text-[12px] text-[var(--co-muted)]">
            Temporary password — copy it now, it is shown once and we cannot show it again. Pass
            it on outside the console; they will be asked to set their own on first sign-in.
          </p>
          <code className="block select-all rounded-md bg-[var(--co-bg)] px-3 py-2 text-[14px] font-semibold tracking-wide text-[var(--co-text)]">
            {password}
          </code>
        </>
      ) : (
        <p className="text-[12px] text-[var(--co-muted)]">
          No password was issued. Use “Reset password” on their row to hand them one.
        </p>
      )}

      <div className="mt-3">
        <Button variant="ghost" onClick={onDismiss}>
          Done
        </Button>
      </div>
    </div>
  );
}
